import { dispatcher, ingenuity, ITween, Linear } from "@quest/base-core";
import { Reel, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
export class ReelGame extends Reel {

  private newCasecadeReelGrid: number[];
  private readonly reelLength: number = 10;

  /**
 * function will remove burst symbol from reel
 * and tween remaining symbols in row(reel)- bottom to top
 * after tweening updates the reel with new reelset
 */
  protected dissolveSymbolPositions(reelId: number): void {
    let parent: any = this.parent;
    const CurrReelBurstOffsets: number[][] = this.getCurrentReelBurstOffsets(reelId);
    if (CurrReelBurstOffsets.length !== 0) {
      const reelBurstSymIndex: number[] = this.findReelBurstIndex(CurrReelBurstOffsets);
      let orginalSym: any = [];
      const numA: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      this.newCasecadeReelGrid = (ingenuity.parserModel as GameParserModel).getReelGrid()[reelId];
      let diff: number[] = numA.filter(function (x) {
        return reelBurstSymIndex.indexOf(x) < 0;
      });
      diff.reverse();
      for (let i: number = 0; i < this.reelLength; i++) {
        orginalSym.push(parent.getSymbolByPos(reelId, i).getStatic());
      }
      const diffLenght: number = diff.length;
      for (let i: number = 0; i < diffLenght; i++) {
        const dropSym = parent.getSymbolByPos(reelId, diff[i]).getStatic();
        const drop = orginalSym.pop();
        const dropTween: ITween = this.game.add.tween(dropSym.position);
        dropTween.to({ y: drop.position.y }, gameConstants.REEL_DROP_TWEEN_DURATION, Linear.None);
        dropTween.start();
        dropTween.onComplete.add(() => {
          this.init(this.newCasecadeReelGrid);
          // this.playZeusUnite(this.newCasecadeReelGrid)
          if (i === diffLenght - 1) {
            this.bounceAfterCascade();
          }
        }, this);
      }
    }
  }

  /**
   * This method get the current reel busrst symbols offsets
   * @param reelId  current spining reel no
   * @returns current spining reel burst/cascade symbols offsets
   */
  private getCurrentReelBurstOffsets(reelId: number): number[][] {
    const cascadeOffsets: number[][][] = (ingenuity.parserModel as GameParserModel).getCascadeOffsets();
    const currentReelBurstOffsets = cascadeOffsets[0].filter((item: any) => item[0] === reelId);
    return currentReelBurstOffsets;
  }

  /**
   * This method finds the drop index of the burst symbols
   * @param arr array of win symbols offsets
   * @returns burst symbols array
   */
  private findReelBurstIndex(arr: number[][]): number[] {
    const secondIndexArray = arr.map((subArray: number[]) => subArray[1]);
    return secondIndexArray;
  }


  /**
  * This method wil execute the bound of the reel after cascading symbols slide in
  */
  private bounceAfterCascade(): void {
    // this block of code is executed when all the symbols have been placed and bounce before the stop is played
    if (!this.model.noStopBounce) {
      const stopBounceAmt: string = gameConstants.STOP_CASCADE_BOUNCE;
      const stopBounceTime: number = gameConstants.STOP_CASCADE_BOUNCE_TIME;
      const stopBounceTimeout: number = gameConstants.STOP_CASCADE_BOUNCE_TIMEOUT;
      const bounce: ITween = this.game.add.tween(this);
      bounce
        .to({ y: this.y + stopBounceAmt }, stopBounceTime, ingenuity.configData.reelStopBounceInEase, false)
        .chain()
        .to({ y: this.model.reelJson[this.reelId].y }, stopBounceTimeout, ingenuity.configData.reelStopBounceOutEase, false);
      bounce.start();
      bounce.onComplete.addOnce(() => {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
          dispatcher.fireEvent(eventDispatchers.CASCADE_SPIN_COMPLETE);
        } else {
          dispatcher.fireEvent(eventDispatchers.FG_CASCADE_SPIN_COMPLETE);
        }
      }, this);
    }
  }
  /**
 * Method overrided to avoid transparent symbol clonning
 */
  public playAnimByPos(pos: any, symReel: any, opts: any) {
    let parent: any = this.parent;
    const sym = parent.getSymbolByPos(this.reelId, pos);
    sym.getStatic().visible = false;
    const icon = sym.getAnimation();
    if (!icon) {
      return;
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
    }
    if (icon.num !== gameConstants.TRANSPARENT_SYMBOL_ID) {
      symReel.addChild(icon);
    }
    icon.visible = !sym.forceHide;
    this.hiddenIcons.push(icon);
    if (!this.checkSymbolInArray(icon)) {
      this.AllIcons.push(icon);
    }
    const staticAnim = icon.json.animations ? icon.json.animations.static : "static";
    const winAnim = icon.json.animations ? icon.json.animations.anim : "animation";
    icon.playAnim(staticAnim, false, 0);
    setTimeout(() => {
      icon.playAnim(winAnim);
    }, 10);
  }
  /**
   * function will fade the spinning symbols except sactter symbol
   * only those symbols will fade which are spinning next to the reel with anticipation
   */
  protected fadeSpinningSymbolOnAnticipation(symbol: any) {
    if (ingenuity.configData.currentAnticipation !== -1 && this.reelId > ingenuity.configData.currentAnticipation && symbol.num !== gameConstants.RESPIN_TRIGGER_SYM) {
      symbol.tint = SlotConstantsBehavior.FADED_SYMBOL;
    }
    else {
      symbol.tint = SlotConstantsBehavior.UNFADED_SYMBOL;
    }
  }
}
